export default __webpack_public_path__ + "static/media/clock-icon.ebfed2f9.svg";